import { ChameleonRequest } from "@repo/chameleon-request";
import { getCookie } from "@repo/client-cookies";
import { BUILD_NUMBER, APP_ENVIRONMENT } from "@/constants";

export const clientRequest = new ChameleonRequest({
  clientName: "Asos.Web.Topshop.Client",
  clientVersion: BUILD_NUMBER || "local",
  defaultTimeout: 15_000,
  defaultRetries: 2,
  defaultRetryDelay: 2_000,
  getXSiteOrigin: async () => {
    if (APP_ENVIRONMENT === "prod") {
      return null;
    }

    // Retrieve x-site-origin from query params then cookies if not found
    const xSiteOriginFromQuery = new URLSearchParams(
      window.location.search,
    ).get("x-site-origin");
    const xSiteOriginCookie = getCookie("x-site-origin") ?? "";

    return xSiteOriginFromQuery || xSiteOriginCookie || null;
  },
});
